/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsChannelLimitResponseDto>
>;
export function request(
  params: API.tms.logisticsChannelLimit.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsChannelLimit/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
